
import {Vue, Component, Prop, Emit, Watch} from 'vue-property-decorator';
	import PreQuestionField from '@/components/PreQuestionField.vue';
	import AppButton from '@/components/AppButton.vue';
	import {MutationType, UserGender} from '@/enums';
	import {GenderOptions, PreQuestion, SpecialEventOption} from '@/types';
	import {getDanishGenderObject, t} from '@/utils';

	@Component({
		components: {
			PreQuestionField,
			AppButton
		}
	})
	export default class PreQuestionSurvey extends Vue {
		private userAge:number = this.$store.getters.getUserAge || 4;
		private userGender:String = this.$store.getters.getUserGender || null;
		private genderOptions: GenderOptions = getDanishGenderObject();
		private showAgeWarning: boolean = false;
		private minAge:number = 4;
		private maxAge:number = 120;

		private get isContinueDisabled(): boolean {
			if (!this.userGender) {
				return true;
			}

			if (!this.isValidUserAge) {
				return true;
			}

			return false;
		}

		private get isValidUserAge(): boolean {
			return this.userAge >= this.minAge && this.userAge <= this.maxAge;
		}

		onUserAgeChange(): void {
			// this.userAge = Math.min(Math.max(this.userAge, this.minAge), this.maxAge);
		}

		@Emit()
		private finish(): void {
			this.$store.commit(MutationType.SET_USER_AGE, this.userAge);
			this.$store.commit(MutationType.SET_USER_GENDER, this.userGender);
		}
	}
